import { useLocalisation } from '@archipro-website/localisation';
import { useVariantSelectionState } from '../context/VariantSelectionContext';
import {
    restatedPriceUnitLabel,
    quantityStepNote,
} from '../util/measured-price';

export interface MeasuredPriceUnit {
    /** "sq ft" and so on when the selected variant's price is restated in the market's unit; otherwise null. */
    unitLabel: string | null;
    /**
     * Set when the price is restated in a unit other than the one the cart
     * counts in, e.g. "Sold in multiples of 10.76 sq ft": the rate shown is
     * not what one press of Add to Cart charges.
     */
    quantityNote: string | null;
}

/**
 * The selected variant's price unit as the market reads it.
 *
 * Requires `VariantSelectionProvider` above it.
 */
export const useMeasuredPriceUnit = (): MeasuredPriceUnit => {
    const { selectedVariant } = useVariantSelectionState();
    const { measurementSystem } = useLocalisation().countryConfig;
    const priceUnit = selectedVariant?.PriceUnit;

    return {
        unitLabel: restatedPriceUnitLabel(priceUnit, measurementSystem),
        quantityNote: quantityStepNote(priceUnit, measurementSystem),
    };
};
